import { type Html, html, rune, View } from 'rune-ts';
import klass from './BottomSection.module.scss';
import { font } from '@services/MarppleShop/shared/typography';

export class BottomSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const background_video_url = is_mobile
      ? '//s3.marpple.co/files/u_4648126/2025/6/original/abee273d56e4035d15997d0fdf68091ad2769a0f1.mp4'
      : '//s3.marpple.co/files/u_4648126/2025/6/original/5b5968ad42eb9e2f239d01ee38e3bf2c42c809481.mp4';
    const texts = {
      title: '유우나처럼 굿즈 만들고 싶다면?',
      sub_title: is_mobile
        ? html.preventEscape(`마플샵 굿즈<br/>파트너스와 함께 해보세요!`)
        : '마플샵 굿즈 파트너스와 함께 해보세요!',
    };

    return is_mobile
      ? html`
          <section class="${klass.container}">
            <div class="${klass.video_wrapper}">
              <video
                autoplay=""
                loop=""
                muted=""
                playsinline=""
                class="${klass.motion_video}"
                src="${background_video_url}"
              ></video>
            </div>
            <div class="${klass.background_gradient}"></div>
            <div class="${klass.content}">
              <div class="${klass.title_wrapper}">
                <div class="${font('28_bold', '14_bold')}">${texts.title}</div>
                <div class="${font('48_bold', '28_bold')}">${texts.sub_title}</div>
              </div>
              <div class="${klass.button_list}">
                <div class="${klass.button_wrapper}">
                  <a
                    href="https://tally.so/r/3xBxgy"
                    target="_blank"
                    class="${klass.apply_button} goods_partners__apply_button_bottom"
                  >
                    <div class="${font('28_bold', '16_bold')}">크리에이터예요</div>
                  </a>
                  <div class="${klass.button_desc} ${font('14_bold')}">직접 지원할래요</div>
                </div>
                <div class="${klass.button_wrapper}">
                  <a
                    href="https://tally.so/r/w2gGqV"
                    target="_blank"
                    class="${klass.apply_button} goods_partners__recommend_button_bottom"
                  >
                    <div class="${font('28_bold', '16_bold')}">팬이에요</div>
                  </a>
                  <div class="${klass.button_desc} ${font('14_bold')}">크리에이터를 추천할래요</div>
                </div>
              </div>
            </div>
          </section>
        `
      : html`
          <section class="${klass.container}">
            <video
              autoplay=""
              loop=""
              muted=""
              playsinline=""
              class="${klass.motion_video}"
              src="${background_video_url}"
            ></video>
            <div class="${klass.background_gradient}"></div>
            <div class="${klass.content}">
              <div class="${klass.title_wrapper}">
                <div class="${font('28_bold', '14_bold')}">${texts.title}</div>
                <div class="${font('48_bold', '28_bold')}">${texts.sub_title}</div>
              </div>
              <div class="${klass.button_wrapper}">
                <a
                  href="https://tally.so/r/3xBxgy"
                  target="_blank"
                  class="${klass.apply_button} goods_partners__apply_button_bottom"
                >
                  <div class="${font('28_bold', '16_bold')}">크리에이터예요</div>
                  <div class="${font('14_bold')}">직접 지원할래요</div>
                </a>
                <a
                  href="https://tally.so/r/w2gGqV"
                  target="_blank"
                  class="${klass.apply_button} goods_partners__recommend_button_bottom"
                >
                  <div class="${font('28_bold', '16_bold')}">팬이에요</div>
                  <div class="${font('14_bold')}">크리에이터를 추천할래요</div>
                </a>
              </div>
            </div>
          </section>
        `;
  }

  override onRender() {
    this.delegate('click', '.goods_partners__apply_button_bottom', () => {
      if (typeof window.gtag == 'function' && G.collabo_type == 'creator') {
        window.gtag('event', '하단버튼클릭_버튜버', { event_category: '하단버튼클릭_버튜버' });
      }
    });

    this.delegate('click', '.goods_partners__recommend_button_bottom', () => {
      if (typeof window.gtag == 'function' && G.collabo_type == 'creator') {
        window.gtag('event', '하단버튼클릭_팬', { event_category: '하단버튼클릭_팬' });
      }
    });
  }
}
